import { render, staticRenderFns } from "./LeftFootSVG.vue?vue&type=template&id=21981c72&scoped=true"
import script from "./LeftFootSVG.vue?vue&type=script&lang=ts"
export * from "./LeftFootSVG.vue?vue&type=script&lang=ts"
import style0 from "./LeftFootSVG.vue?vue&type=style&index=0&id=21981c72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21981c72",
  null
  
)

export default component.exports